import React from 'react'

function InstituteAbout() {
    return (
        <section className='min-h-screen items-center'>
            <div className='max-w-7xl px-2 mx-auto text-center mt-10'>

                <h1 class="mb-4 text-4xl font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-6xl dark:text-white">We invest in the <span class="underline underline-offset-3 decoration-8 decoration-blue-400 dark:decoration-blue-600">world’s potential</span></h1>
                <p class="text-lg py-4 font-normal text-gray-500 lg:text-xl dark:text-gray-400">Here at Flowbite we focus on markets where technology, innovation, and capital can unlock long-term value and drive economic growth.</p>

            </div>
        </section>
    )
}

export default InstituteAbout